import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthForm from "../../components/AuthForm";
import { sendRequest, errorMessage } from "../../utils/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [generalError, setGeneralError] = useState("");
  // const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!email.trim()) {
      setError("Email is required.");
      return;
    }
    
    setLoading(true);
    setError("");
    setGeneralError("");

    try {
      // 🔹 Detect subdomain for multi-tenant context
      const hostname = window.location.hostname; // e.g. demo-hotel.wiventory.com
      const subdomain = hostname.split('.')[0];  // e.g. demo-hotel
      // console.log("Current tenant:", subdomain);
      const response = await sendRequest("POST", "/auth/reset-password/request", { email });
      navigate("/forgot-password/success");
      // setSuccess(true);
    } catch (err: any) {
      console.log(err);
      const msg = errorMessage(err.status)?.msg || err.message;
      setGeneralError(msg || "Failed to send reset link.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <AuthForm
      title="Forgot Password"
      inputs={[
        {
          label: "Email Address",
          type: "email",
          value: email,
          onChange: setEmail,
          error: error,
          placeholder: "Enter your email",
        },
      ]}
      errorMessage={generalError}
      buttonText="Send Reset Link"
      disableButton={loading}
      onSubmit={handleSubmit}
      loadSpinner={loading}
      extra={
        <div className="flex flex-col items-center">
          <p className="text-gray-500 text-xs mt-2">
            The reset link will expire in <b>30 minutes</b>.
          </p>
          <p
            className="text-blue-600 text-sm mt-3 cursor-pointer hover:underline"
            onClick={() => navigate("/login")}
          >
            Back to Login
          </p>
        </div>
      }
    />
  );
}
